<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
<!--      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">-->
<!--        <img v-if="logo" :src="$OSSURL('logo-circle')" class="sidebar-logo1" alt="">-->
<!--       <h1 class="sidebar-title1">-->
<!--          <span>{{ title }}</span>-->
<!--          <span>{{ desc }}</span>-->
<!--       </h1>-->
<!--      </router-link>-->
      <router-link key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="$OSSURL('logo-circle')" class="sidebar-logo2" alt="">
        <div class="sidebar-title">
          <span class="sidebar-title-one">{{ title }}</span>
          <span>{{ desc }}</span>
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '和瑞新风系统',
      desc: '本地管理端',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 145px;
  text-align: center;
  overflow: hidden;
  margin-bottom: 30px;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo1 {
      display: block;
      width: 40px;
      margin: 30px auto 0;
    }

    & .sidebar-logo2 {
      display: block;
      width: 50px;
      margin: 30px auto 0;
    }

    & .sidebar-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0 0 0;
      color: #fff;
      line-height: initial;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.sidebar-title-one{
  margin-bottom: 10px;
}
</style>
